<template>
    <nav v-if="resources.length > 0 && (hasPreviousPages || hasMorePages)" class="pagination flex">
        <div class="w-1/2">
            <!-- Previous Link -->
            <button
                :disabled="!hasPreviousPages"
                :class="{
                    'pagination__link': true,
                    'disabled': !hasPreviousPages,
                }"
                rel="prev"
                @click.prevent="selectPreviousPage()"
            >
                Previous
            </button>
        </div>

        <div class="w-1/2 text-right">
            <!-- Next Link -->
            <button
                :disabled="!hasMorePages"
                :class="{
                    'pagination__link': true,
                    'disabled': !hasMorePages,
                }"
                rel="next"
                @click.prevent="selectNextPage()"
            >
                Next
            </button>
        </div>
    </nav>
</template>

<script>
export default {
    props: ['resources', 'response'],

    methods: {
        /**
         * Select the previous page.
         */
        selectPreviousPage() {
            this.$emit('previous')
        },
        /**
         * Select the next page.
         */
        selectNextPage() {
            this.$emit('next')
        },
    },
    computed: {
        /**
         * Determine if prior pages are available.
         */
        hasPreviousPages: function() {
            return Boolean(this.response && this.response.prev_page_url)
        },
        /**
         * Determine if more pages are available.
         */
        hasMorePages: function() {
            return Boolean(this.response && this.response.next_page_url)
        },
    },
}
</script>

<style lang="scss" scoped>
    .pagination {
        @apply .mt-4;
        
        &__link {
            @apply .text-grey .text-sm .border-0 .bg-transparent .cursor-pointer;

            outline: 0;
           
            transition: all 0.2s ease-in-out;

            &:hover {
                @apply .text-blue .opacity-100;
            }
            &:disabled {
                @apply .opacity-50;

                cursor: not-allowed;

                &:hover {
                    @apply .text-grey;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/PaginationLinks.vue